import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../helpers";
import { ForgeMeta } from "./meta";

export const ForgeProjectTag = z.array(z.string()).default([]);

export const ForgeProjectAccessMode = z.enum(["InviteOnly", "Open"]);

export const ForgeProject = z.object({
  createdAt: z.coerce.date(),
  createdByUserId: z.string().optional(),
  fpContextId: z.string(),
  id: z.string(),
  instruction: z.string().nullable(),
  meta: ForgeMeta,
  name: z.string(),
  tags: ForgeProjectTag,
  updatedAt: z.coerce.date().optional(),
  workspaceId: z.string(),
  accessMode: ForgeProjectAccessMode,
  isArchived: z.boolean().optional(),
});

export type ForgeProjectTag = z.infer<typeof ForgeProjectTag>;
export type ForgeProjectAccessMode = z.infer<typeof ForgeProjectAccessMode>;
export type ForgeProject = z.infer<typeof ForgeProject>;
export type CreateForgeProject = Omit<DbCreateInputOmit<ForgeProject>, "workspaceId" | "createdByUserId">;
export type UpdateForgeProject = Omit<DbUpdate<ForgeProject>, "fpContextId" | "workspaceId" | "createdByUserId">;
